import { render, staticRenderFns } from "./LocalityList.vue?vue&type=template&id=ab40a8f2&"
import script from "./LocalityList.vue?vue&type=script&lang=js&"
export * from "./LocalityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports